import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import CartSheet from "@/components/site/CartSheet";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import EditorialMarquee from "@/components/site/EditorialMarquee";
import AboutSection from "@/components/site/AboutSection";
import MenuSection from "@/components/site/MenuSection";
import ReviewsSection from "@/components/site/ReviewsSection";
import Builder from "@/components/site/Builder";
import VendingSection from "@/components/site/VendingSection";
import ServicesSection from "@/components/site/ServicesSection";
import ContactSection from "@/components/site/ContactSection";
import Footer from "@/components/site/Footer";
import PaymentReturn from "@/components/site/PaymentReturn";
import OrderTracking from "@/components/site/OrderTracking";

function App() {
  const path = typeof window !== "undefined" ? window.location.pathname : "";
  const isPayment = path.startsWith("/payment");
  const isTrack = path.startsWith("/track");
  const isSpecial = isPayment || isTrack;

  useEffect(() => {
    if (isSpecial) return;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (time) => {
      lenis.raf(time);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      delete window.__lenis;
    };
  }, [isSpecial]);

  if (isPayment) return <PaymentReturn />;
  if (isTrack) return <OrderTracking />;

  return (
    <CartProvider>
      <AuthProvider>
        <div className="App relative bg-beige text-coffee">
          <Navbar />
          <main>
            <Hero />
            <EditorialMarquee />
            <MenuSection />
            <Builder />
            <VendingSection />
            <AboutSection />
            <ServicesSection />
            <ReviewsSection />
            <ContactSection />
          </main>
          <Footer />
          <CartSheet />
          <Toaster position="top-center" richColors />
        </div>
      </AuthProvider>
    </CartProvider>
  );
}

export default App;
